// dependencies
import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import { parseISO } from "date-fns";
import { Search, Eraser } from "lucide-react";

// components
import TextInput from "Components/Inputs/Text";

// css
import css from "./SearchForm";

const SearchForm = (props) => {
	const { url, startTime, endTime, updateFilter, getBreadcrumbs } = props;

	const handleUrlChange = (value) => {
		updateFilter("url", value);
	};
	const handleStartTimeChange = (value) => {
		updateFilter("startTime", value.toISOString());
	};
	const handleEndTimeChange = (value) => {
		updateFilter("endTime", value.toISOString());
	};
	const handleClear = () => {
		updateFilter("url", "");
		updateFilter("startTime", "");
		updateFilter("endTime", "");
		getBreadcrumbs();
	};

	return (
		<div className={css.main}>
			<div className={css.labelledInput}>
				<label htmlFor="urlInput">URL</label>
				<TextInput id="urlInput" type="text" value={url} onChange={handleUrlChange} />
			</div>
			<div className={css.labelledInput}>
				<label htmlFor="startTimeInput">Start Time</label>
				<DatePicker
					id="startTimeInput"
					className={css.input}
					selected={startTime.length ? parseISO(startTime) : ""}
					onChange={handleStartTimeChange}
					showTimeSelect
					dateFormat="Pp"
					popperClassName={css.datePicker}
					popperPlacement="top-end"
					shouldCloseOnSelect={false}
				/>
			</div>
			<div className={css.labelledInput}>
				<label htmlFor="endTimeInput">End Time</label>
				<DatePicker
					id="endTimeInput"
					className={css.input}
					selected={endTime.length ? parseISO(endTime) : ""}
					onChange={handleEndTimeChange}
					showTimeSelect
					dateFormat="Pp"
					popperClassName={css.datePicker}
					popperPlacement="top-end"
					shouldCloseOnSelect={false}
				/>
			</div>

			<div
				className={`${css.searchButton} ${!url.length && !startTime.length && !endTime.length && css.disabled}`}
				onClick={getBreadcrumbs}
			>
				<div className={css.iconWrapper}>
					<Search size={16} />
				</div>
			</div>

			<div className={css.clearButton} onClick={handleClear}>
				<div className={css.iconWrapper}>
					<Eraser size={16} />
				</div>
			</div>
		</div>
	);
};

SearchForm.propTypes = {
	url: PropTypes.string.isRequired,
	startTime: PropTypes.string.isRequired,
	endTime: PropTypes.string.isRequired,
	updateFilter: PropTypes.func.isRequired,
	getBreadcrumbs: PropTypes.func.isRequired,
};

export default SearchForm;
